export const COMPANY_PRODUCT_DELETE_RESET = 'COMPANY_PRODUCT_DELETE_RESET'
export const COMPANY_PRODUCT_DELETE_SET_ERROR = 'COMPANY_PRODUCT_DELETE_SET_ERROR'
export const COMPANY_PRODUCT_DELETE_SET_DELETED = 'COMPANY_PRODUCT_DELETE_SET_DELETED'
export const COMPANY_PRODUCT_DELETE_TOGGLE_LOADING = 'COMPANY_PRODUCT_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/company_product/delete/mutation_types.js